import React from 'react';
import './PageLoader.css';

function PageLoader({ message = 'Carregando...' }) {
  return (
    <div className="page-loader">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Preparate Questões"
        className="page-loader-logo"
      />
      <div className="page-loader-bar">
        <div className="page-loader-bar-fill" />
      </div>
      <div className="page-loader-message">{message}</div>
    </div>
  );
}

export default PageLoader;
